import React from 'react';
import { usePermissions } from '@/hooks/usePermissions';
import { USER_ROLES } from '@/types/user';

/**
 * Sticky red banner shown on every page when the current user is read-only.
 * Uses role from `/permissions/me` (not JWT). API enforces writes via the matrix.
 */
export const ReadOnlyBanner: React.FC = () => {
  const { role, isLoading } = usePermissions();

  if (isLoading || role !== USER_ROLES.READ_ONLY) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-[9999] w-full bg-red-600 text-white text-center px-3 py-1.5 text-[13px] font-bold tracking-[0.08em] uppercase shadow-[0_1px_3px_rgba(0,0,0,0.2)]"
    >
      Read Only — you can view data but cannot make changes
    </div>
  );
};

export default ReadOnlyBanner;
